import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "h-12"
}
const _hoisted_4 = { class: "max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_5 = { class: "-mt-8 sm:-mt-8 sm:flex sm:items-end sm:space-x-5" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "mt-6 sm:flex-1 sm:min-w-0 sm:flex sm:items-center sm:justify-end sm:space-x-6 sm:pb-1" }
const _hoisted_9 = { class: "sm:hidden md:block mt-6 min-w-0 flex-1" }
const _hoisted_10 = { class: "text-2xl font-bold text-gray-900 truncate" }
const _hoisted_11 = { class: "mt-4 max-w-3xl mx-auto sm:px-6 lg:px-8 overflow-x-hidden" }
const _hoisted_12 = { class: "m-2 hidden lg:block" }
const _hoisted_13 = {
  role: "list",
  class: "space-y-4 md:flex md:space-y-0 md:space-x-8"
}
const _hoisted_14 = { class: "md:flex-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium" }, "コンテンツの選択", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "md:flex-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium" }, "祈願内容の入力", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "md:flex-1" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium" }, "お支払い", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 0,
  class: "mx-4 mt-4"
}
const _hoisted_24 = {
  role: "list",
  class: "divide-y"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "grow text-sm font-medium" }
const _hoisted_27 = { class: "text-gray-900" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "grow" }, null, -1)
const _hoisted_29 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "email-error"
}
const _hoisted_30 = {
  key: 1,
  class: "mx-4"
}
const _hoisted_31 = { class: "text-sm font-medium space-y-1" }
const _hoisted_32 = { class: "text-gray-900" }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_35 = {
  id: "tabs-1-panel-1",
  class: "p-0.5 -m-0.5 rounded-lg",
  "aria-labelledby": "tabs-1-tab-1",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_36 = ["onDrop"]
const _hoisted_37 = {
  key: 0,
  type: "button",
  class: "mt-4 relative block w-full border-2 border-gray-300 border-dashed rounded-lg p-12 text-center"
}
const _hoisted_38 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  width: "42",
  height: "42",
  class: "mx-auto h-12 w-12"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("path", { d: "M447.1 32h-384C28.64 32-.0091 60.65-.0091 96v320c0 35.35 28.65 64 63.1 64h384c35.35 0 64-28.65 64-64V96C511.1 60.65 483.3 32 447.1 32zM111.1 96c26.51 0 48 21.49 48 48S138.5 192 111.1 192s-48-21.49-48-48S85.48 96 111.1 96zM446.1 407.6C443.3 412.8 437.9 416 432 416H82.01c-6.021 0-11.53-3.379-14.26-8.75c-2.73-5.367-2.215-11.81 1.334-16.68l70-96C142.1 290.4 146.9 288 152 288s9.916 2.441 12.93 6.574l32.46 44.51l93.3-139.1C293.7 194.7 298.7 192 304 192s10.35 2.672 13.31 7.125l128 192C448.6 396 448.9 402.3 446.1 407.6z" }, null, -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = {
  key: 1,
  class: "mt-2 block text-sm font-medium text-gray-900"
}
const _hoisted_42 = ["src"]
const _hoisted_43 = ["onDrop"]
const _hoisted_44 = { class: "mt-4 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 sm:gap-x-6" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "absolute top-1 right-1 rounded-full h-8 w-8 bg-red-600 flex justify-center items-center" }
const _hoisted_48 = ["onDrop"]
const _hoisted_49 = {
  type: "button",
  class: "mt-4 relative block w-full border-2 border-gray-300 border-dashed rounded-lg p-12 text-center"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "mt-2 block text-xs font-medium text-gray-600" }, " 人工衛星に搭載する画像や動画をアップロードしてください ", -1)
const _hoisted_51 = {
  key: 3,
  class: "mt-2 text-sm text-red-600",
  id: "email-error"
}
const _hoisted_52 = {
  key: 2,
  class: "bg-white mx-4"
}
const _hoisted_53 = { class: "max-w-7xl mx-auto px-4 pt-4 pb-16 sm:px-6 sm:pt-8 sm:pb-24 lg:px-8 xl:px-2 xl:pt-14" }
const _hoisted_54 = { class: "max-w-lg mx-auto grid grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-2" }
const _hoisted_55 = { class: "max-w-lg mx-auto w-full" }
const _hoisted_56 = { class: "flow-root" }
const _hoisted_57 = {
  role: "list",
  class: "-my-6 divide-y divide-gray-200"
}
const _hoisted_58 = { class: "py-6 flex space-x-6" }
const _hoisted_59 = { class: "flex-auto" }
const _hoisted_60 = { class: "space-y-1 mb-4 sm:flex sm:items-start sm:justify-between sm:space-x-6" }
const _hoisted_61 = { class: "flex-auto text-sm font-medium space-y-1" }
const _hoisted_62 = { class: "text-gray-900" }
const _hoisted_63 = ["innerHTML"]
const _hoisted_64 = {
  key: 0,
  class: "mt-4 scrolling-touch items-start"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-gray-400" }, "祈願内容", -1)
const _hoisted_66 = ["innerHTML"]
const _hoisted_67 = {
  key: 1,
  class: "mt-4 overflow-x-scroll scrolling-touch items-start"
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-gray-400" }, "写経データ", -1)
const _hoisted_69 = { class: "flex flex-nowrap" }
const _hoisted_70 = { class: "relative flex flex-col mx-2 w-64 justify-center items-center p-2 border border-gray-100 rounded-md" }
const _hoisted_71 = ["src"]
const _hoisted_72 = {
  key: 2,
  class: "mt-4 overflow-x-scroll scrolling-touch items-start"
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium text-gray-400" }, "搭載データ", -1)
const _hoisted_74 = { class: "flex flex-nowrap" }
const _hoisted_75 = ["src"]
const _hoisted_76 = { class: "text-sm font-medium text-gray-500 mt-10 space-y-6" }
const _hoisted_77 = { class: "flex justify-between border-t border-gray-200 text-gray-900 pt-6" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("dt", { class: "text-base" }, "お支払い金額", -1)
const _hoisted_79 = { class: "text-base" }
const _hoisted_80 = { class: "max-w-lg mx-auto w-full" }
const _hoisted_81 = { class: "mt-6" }
const _hoisted_82 = { class: "mt-6" }
const _hoisted_83 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "email-error"
}
const _hoisted_84 = {
  key: 3,
  class: "mx-4 my-8 flex justify-end"
}
const _hoisted_85 = ["onClick"]
const _hoisted_86 = ["onClick"]

import { computed, onBeforeMount, onMounted, ref } from "vue";
import * as yup from "yup";
import { useField, useForm, FieldContext } from "vee-validate";
import { loadStripe, Stripe, StripeElements } from "@stripe/stripe-js";
import Menu from "@/models/Menu";
import Temple from "@/models/Temple";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { uuid } from "vue-uuid";
import { Auth, Storage } from "aws-amplify";
import axios from "axios";

import AppHeader from "@/components/AppHeader.vue";

const publisher_key =
  "pk_live_51KUPkkBvZuQJtNEWTWFOlP47fwXaRAajHBJeBRg7lfFDv82XCFLdmR7qe17br6I83FeZjZrOgXdAlwQOiBkLQ9Tj00ZkybZsy5";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputWishView',
  setup(__props) {


const store = useStore();
const route = useRoute();
const router = useRouter();

const temple_id = ref<string>("");
const temple = ref<Temple>({} as Temple);
const menus = ref<Menu[]>([]);

const formSchema = yup.object({
  wish_contents: yup.string().required('必須項目です'),
});

useForm({ validationSchema: formSchema });

const wish_contents_field = useField<string>("wish_contents");

const wish_contents = wish_contents_field.value;
const wish_contents_error = wish_contents_field.errorMessage;

const wish_contents_v = computed<string>(() => {
  if (!wish_contents.value) {
    return "";
  }

  return wish_contents.value.replace(/\n/g, "<br />");
});

const syakyo_image_url = ref<string | null>(null);

const resource_urls = ref<string[]>([]);

const step = ref<string>("select_menu");

const error_message = ref<string>("");

// const publisher_key =
//   "pk_test_51KUPkkBvZuQJtNEW1ltcwY2dZtsTtzZHiUCVnJQiunJTXh284TGn5CIHIbkjXtU8GHReZdQVoaiQGUo2Hb6YqED6004X2uWhuS";
let stripe: Stripe | null = null;
let stripeElements: StripeElements | null = null;

const selected_menu = computed<Menu | null>(() => {
  return menus.value.find((check) => check.is_selected) as Menu | null;
});

const price = computed<number | null>(() => {
  if (!selected_menu.value) {
    return null;
  }

  return selected_menu.value.temple_prices[temple_id.value] as number | null;
});

const refresh = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      temple.value = await Temple.get(temple_id.value);
      const result = await Menu.searchByTemple(temple_id.value);

      result.menus.forEach((menu) => {
        if (menu.menu_type !== "for_wish") {
          return;
        }
        menus.value.push(menu);
      });
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const clearInput = () => {
  wish_contents.value = "";
  syakyo_image_url.value = "";
  resource_urls.value.length = 0;
};

const onSelectionChanged = (menu: Menu) => {
  menus.value.forEach((check) => {
    check.is_selected = check == menu;
  });
};

const skyakyo_upload_file = ref<HTMLInputElement>();
const selectSyakyoFile = () => {
  const element = skyakyo_upload_file.value;
  element?.click();
};

const onUploadSyakyoFileChanged = (e: Event) => {
  const element = e.target as HTMLInputElement;

  if (!element.files) {
    return;
  }

  const file = element.files[0];

  element.value = "";

  uploadSyakyoImage(file);
};

const onSyakyoImageDropped = (e: DragEvent) => {
  // console.log(e);
  e.preventDefault();

  // console.log("1");
  if (!e.dataTransfer?.files.length) {
    return;
  }

  // console.log("2");
  const file = e.dataTransfer?.files[0];

  uploadSyakyoImage(file);
};

const uploadSyakyoImage = (file: File) => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      // console.log(file);

      const split = file.name.split(".");
      const filename = uuid.v4();
      const extension = split[split.length - 1];
      const contentType = extension == "png" ? "image/png" : "image/jpg";

      Storage.configure({ customPrefix: { public: "orders" } });
      const s3response = await Storage.put(`/${filename}.${extension}`, file, {
        contentType: contentType,
      });

      // console.log(s3response);

      syakyo_image_url.value = `${process.env.VUE_APP_HOST}/orders/${filename}.${extension}`;
      // console.log(syakyo_image_url);
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const media_upload_file = ref<HTMLInputElement>();
const selectMediaFile = () => {
  const element = media_upload_file.value;
  element?.click();
};

const onUploadMediaFileChanged = (e: Event) => {
  const element = e.target as HTMLInputElement;

  if (!element.files) {
    return;
  }

  const file = element.files[0];

  element.value = "";

  uploadMediaImage(file);
};

const onMediaImageDropped = (e: DragEvent) => {
  // console.log(e);
  e.preventDefault();

  // console.log("1");
  if (!e.dataTransfer?.files.length) {
    return;
  }

  // console.log("2");
  const file = e.dataTransfer?.files[0];

  uploadMediaImage(file);
};

const uploadMediaImage = (file: File) => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      // console.log(file);

      const split = file.name.split(".");
      const filename = uuid.v4();
      const extension = split[split.length - 1];
      const contentType = extension == "png" ? "image/png" : "image/jpg";

      Storage.configure({ customPrefix: { public: "orders" } });
      const s3response = await Storage.put(`/${filename}.${extension}`, file, {
        contentType: contentType,
      });

      // console.log(s3response);

      resource_urls.value.push(`${process.env.VUE_APP_HOST}/orders/${filename}.${extension}`);
      // console.log(syakyo_image_url);
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const removeMediaResource = (url) => {
  resource_urls.value.splice(resource_urls.value.indexOf(url), 1);
};

const previous = () => {
  error_message.value = "";
  if (step.value == "input") {
    clearInput();
    step.value = "select_menu";
  } else if (step.value == "confirm") {
    step.value = "input";
  } else if (step.value == "payment") {
    step.value = "confirm";
  }
};

const onSelectedMenu = (menu: Menu) => {
  menu.is_selected = true;
  next();
};

const next_step = computed<string>(() => {
  if (step.value == "select_menu") {
    return 'input';
  } else if (step.value == "input") {
    return "confirm";
  }
  return "payment";
});

const next_step_label = computed<string>(() => {
  switch (next_step.value) {
    case 'input':
      return "搭載データ入力";
    case 'confirm':
      return "申込内容の確認";
    default:
      return "お支払い";
  }
});

const next = async () => {
  store.dispatch("setLoading", true);
  console.log(`next()`);
  setTimeout(async () => {
    try {
      const valid = await validate();
      if (!valid) {
        return;
      }

      if (step.value == "select_menu") {
        step.value = "input";
      } else if (step.value == "input") {
        step.value = "confirm";
      } else if (step.value == "confirm") {
        step.value = "payment";
        createPaymentSheet();
      } else if (step.value == "payment") {
        doPayment();
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const validate = async (): Promise<boolean> => {
  error_message.value = "";

  if (step.value == "select_menu") {
    if (!selected_menu.value) {
      error_message.value = "コンテンツを選択してください";
    }
  }

  if (step.value == "input") {
    if (selected_menu!.value?.accept_text) {
      await wish_contents_field.validate();
      error_message.value = wish_contents_error.value ?? "";
    } else if (selected_menu!.value?.accept_syakyo && !syakyo_image_url.value) {
      error_message.value = "写経を撮影した画像をアップロードしてください";
    }
  }

  return !error_message.value;
};

const payment = ref<HTMLDivElement>();

const createPaymentSheet = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const cognitoUser = await Auth.currentUserInfo();
      const id = cognitoUser.attributes.sub;

      const param = {
        customer_id: id,
        temple_id: temple_id.value,
        menu_id: selected_menu.value?.id,
        applyment_method: "app",
        attributes: {
          wish: wish_contents.value,
        },
        syakyo_url: syakyo_image_url.value,
        media_urls: resource_urls.value,
      };

      console.log(param);

      const user = await Auth.currentAuthenticatedUser();

      const config = {
        headers: {
          Authorization: `${user.signInUserSession.idToken.jwtToken}}`,
        },
      };

      const response = await axios.post(
        `${process.env.VUE_APP_API_HOST}/orders`,
        param,
        config
      );

      console.log(response);

      const secret = response.data.data.payment_intent as string;

      stripeElements = stripe!.elements({
        clientSecret: secret,
      });

      // const cardElement = elements.create("card");
      // const cardHost = $refs.card as HTMLDivElement;
      // cardElement.mount(cardHost);

      const paymentElement = stripeElements.create("payment");
      const paymentHost = payment.value as HTMLDivElement;
      paymentElement.mount(paymentHost);
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const doPayment = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const { error } = await stripe!.confirmPayment({
        elements: stripeElements!,
        redirect: "if_required",
      });

      // console.log(error);

      if (error) {
        error_message.value = error.message!;
        return;
      }

      router.replace("/me/orders");
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

onBeforeMount(async () => {
  stripe = await loadStripe(publisher_key);
});

onMounted(() => {
  temple_id.value = route.params.temple_id as string;
  refresh();
});

return (_ctx: any,_cache: any) => {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader),
    _createElementVNode("div", null, [
      (temple.value.main_image_url)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("img", {
              class: "h-24 w-full object-cover lg:h-24",
              src: temple.value.main_image_url ?? require('@/assets/images/empty.png'),
              alt: ""
            }, null, 8, _hoisted_2)
          ]))
        : _createCommentVNode("", true),
      (!temple.value.main_image_url)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (temple.value.selfie_image_url)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "h-16 w-16 rounded-full ring-4 ring-white bg-white sm:h-16 sm:w-16",
                  src: 
              temple.value.selfie_image_url ?? require('@/assets/images/no-selfie-temple.png')
            ,
                  alt: ""
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h1", _hoisted_10, _toDisplayString(temple.value.name) + " 宇宙祈願のお申し込み ", 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("nav", _hoisted_12, [
        _createElementVNode("ol", _hoisted_13, [
          _createElementVNode("li", _hoisted_14, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass(["group pl-4 py-2 flex flex-col border-l-4 md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4", {
              'border-stone-600 hover:border-stone-800':
                step.value == 'select_menu' || step.value == 'input' || step.value == 'confirm',
            }])
            }, _hoisted_16, 2)
          ]),
          _createElementVNode("li", _hoisted_17, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass(["pl-4 py-2 flex flex-col border-l-4 md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4", {
              'border-stone-600 hover:border-stone-800':
                step.value == 'input' || step.value == 'confirm',
            }]),
              "aria-current": "step"
            }, _hoisted_19, 2)
          ]),
          _createElementVNode("li", _hoisted_20, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass(["pl-4 py-2 flex flex-col border-l-4 md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4", {
              'border-stone-600 hover:border-stone-800': step.value == 'confirm',
            }]),
              "aria-current": "step"
            }, _hoisted_22, 2)
          ])
        ])
      ]),
      (step.value == 'select_menu')
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("ul", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menus.value, (menu) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: menu.id,
                  class: "flex p-6 mb-4 space-x-6 bg-white justify-streatch items-center",
                  onClick: ($event: any) => (onSelectedMenu(menu))
                }, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("h3", _hoisted_27, _toDisplayString(menu.name), 1)
                  ]),
                  _hoisted_28,
                  _createVNode(_component_fa, {
                    icon: "angle-right",
                    class: "text-gray-400"
                  })
                ], 8, _hoisted_25))
              }), 128))
            ]),
            (!!error_message.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(error_message.value), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (step.value == 'input')
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("h3", _hoisted_32, _toDisplayString(selected_menu.value?.name), 1),
              _createElementVNode("p", {
                class: "text-gray-500",
                innerHTML: selected_menu.value?.description
              }, null, 8, _hoisted_33)
            ]),
            (selected_menu.value?.accept_text)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("textarea", {
                        rows: "5",
                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md",
                        placeholder: "人工衛星に搭載する祈願内容を入力してください",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(wish_contents) ? (wish_contents).value = $event : null))
                      }, null, 512), [
                        [_vModelText, _unref(wish_contents)]
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (selected_menu.value?.accept_syakyo)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "bg-white mt-4 p-4",
                  onDrop: _withModifiers(onSyakyoImageDropped, ["stop"]),
                  onClick: selectSyakyoFile
                }, [
                  (selected_menu.value?.accept_syakyo)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_37, [
                        (!syakyo_image_url.value)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_38, _hoisted_40))
                          : _createCommentVNode("", true),
                        (!syakyo_image_url.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_41, " 写経を撮影した画像をアップロードしてください "))
                          : _createCommentVNode("", true),
                        (!!syakyo_image_url.value)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 2,
                              src: syakyo_image_url.value,
                              class: "object-center text-center w-96"
                            }, null, 8, _hoisted_42))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("input", {
                    type: "file",
                    ref_key: "skyakyo_upload_file",
                    ref: skyakyo_upload_file,
                    class: "w-0",
                    onChange: onUploadSyakyoFileChanged
                  }, null, 544)
                ], 40, _hoisted_36))
              : _createCommentVNode("", true),
            (selected_menu.value?.accept_photo || selected_menu.value?.accept_video)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  onDrop: _withModifiers(onMediaImageDropped, ["stop"]),
                  onClick: selectMediaFile
                }, [
                  _createElementVNode("ul", _hoisted_44, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resource_urls.value, (resource_url) => {
                      return (_openBlock(), _createElementBlock("li", { key: resource_url }, [
                        _createElementVNode("button", {
                          class: "relative bg-white shadow sm:rounded-lg",
                          onClick: ($event: any) => (removeMediaResource(resource_url))
                        }, [
                          _createElementVNode("img", {
                            src: resource_url,
                            class: "w-full"
                          }, null, 8, _hoisted_46),
                          _createElementVNode("div", _hoisted_47, [
                            _createVNode(_component_fa, {
                              icon: "trash",
                              class: "text-white"
                            })
                          ])
                        ], 8, _hoisted_45)
                      ]))
                    }), 128)),
                    _createElementVNode("li", {
                      class: "relative p-4 bg-white",
                      onDragenter: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                      onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                      onDrop: onMediaImageDropped
                    }, [
                      _createElementVNode("div", {
                        onDrop: _withModifiers(onMediaImageDropped, ["stop"]),
                        onClick: selectMediaFile
                      }, [
                        _createElementVNode("button", _hoisted_49, [
                          _createVNode(_component_fa, {
                            icon: "image",
                            class: "text-gray-600 text-lg"
                          }),
                          _hoisted_50
                        ])
                      ], 40, _hoisted_48)
                    ], 32)
                  ]),
                  _createElementVNode("input", {
                    type: "file",
                    ref_key: "media_upload_file",
                    ref: media_upload_file
                  }, null, 512)
                ], 40, _hoisted_43))
              : _createCommentVNode("", true),
            (!!error_message.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(error_message.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("input", {
              type: "file",
              ref_key: "media_upload_file",
              ref: media_upload_file,
              onChange: onUploadMediaFileChanged,
              class: "hidden",
              accept: "image/*"
            }, null, 544)
          ]))
        : _createCommentVNode("", true),
      (step.value == 'confirm' || step.value == 'payment')
        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("ul", _hoisted_57, [
                      _createElementVNode("li", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("h3", _hoisted_62, _toDisplayString(selected_menu.value?.name), 1),
                              _createElementVNode("p", {
                                class: "text-gray-500",
                                innerHTML: selected_menu.value?.description
                              }, null, 8, _hoisted_63)
                            ])
                          ]),
                          (_unref(wish_contents))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                _hoisted_65,
                                _createElementVNode("div", {
                                  class: "flex flex-nowrap",
                                  innerHTML: wish_contents_v.value
                                }, null, 8, _hoisted_66)
                              ]))
                            : _createCommentVNode("", true),
                          (syakyo_image_url.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                _hoisted_68,
                                _createElementVNode("div", _hoisted_69, [
                                  _createElementVNode("div", _hoisted_70, [
                                    _createElementVNode("img", {
                                      src: syakyo_image_url.value,
                                      class: "w-64"
                                    }, null, 8, _hoisted_71)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (resource_urls.value.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                _hoisted_73,
                                _createElementVNode("div", _hoisted_74, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resource_urls.value, (resource_url) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: resource_url,
                                      class: "relative flex flex-col mx-2 w-64 justify-center items-center p-2 border border-gray-100 rounded-md"
                                    }, [
                                      _createElementVNode("img", {
                                        src: resource_url,
                                        class: "w-64"
                                      }, null, 8, _hoisted_75)
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("dl", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, [
                      _hoisted_78,
                      _createElementVNode("dd", _hoisted_79, "¥" + _toDisplayString(price.value), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("form", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("div", {
                        ref_key: "payment",
                        ref: payment
                      }, null, 512)
                    ])
                  ])
                ]),
                (!!error_message.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_83, _toDisplayString(error_message.value), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (step.value != 'select_menu')
        ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
            (step.value == 'input' || step.value == 'confirm')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "mr-4 inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white",
                  onClick: _withModifiers(previous, ["prevent"])
                }, " 戻る ", 8, _hoisted_85))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white",
              onClick: _withModifiers(next, ["prevent"])
            }, _toDisplayString(next_step_label.value), 9, _hoisted_86)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})